import React from 'react';
import {
    withStyles,
    withRouter
} from '../../material-ui';

import MBack from '../view/MBack';
import IMEventEmitter from '../../net/IMEventEmitter';
import FIMUtils from "../../im/FIMUtils";
import StringUtils from '../../net/IMStringUtils';


import './redBag.css'

const BG = require('../../images/bg/redBagBg.png')

class RedBag extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            userAvatar: null,
            redbagText: '',
            userName: '',
            type: 2, //拼手气红包，普通红包
            redBagMoney: 0,
            yRedBagLenght: 0,
            leftnum: 0,
            dateTime: '',
            list: [],
        }

        // console.log('RedBag', this.props.match.params);
    }
    componentDidMount() {
        //检查红包状态
        IMEventEmitter.on('S2C_MSG_GET_REDBAG_INFO_REP', this.onRedBagInfo, this);
        FIMUtils.RedBagInfo(this.props.match.params.id)

        this.setState({
            redbagText: this.props.location.data
        })
    }
    componentWillUnmount() {
        IMEventEmitter.off('S2C_MSG_GET_REDBAG_INFO_REP', this.onRedBagInfo, this);


    }
    //监听红包状态
    onRedBagInfo = (e) => {

        let { headurl, nickname, records, redbagtype, leftnum, redbagtime } = e
        console.log(e);
        let money = 0;
        for (const key in records) {
            records[key].nickname = StringUtils.decode(records[key].nickname);

            if (records[key].nickname.length > 13) {
                records[key].nickname = records[key].nickname.substring(0, 13) + '...'
            }
            records[key].headurl = StringUtils.decode(records[key].headurl);
            // let getTime = StringUtils.decode(records[key].gettime);
            records[key].gettime2 = this.timestampToTime(records[key].gettime);
            records[key].isYQ = false;

            for (const i in records) {
                if (records[key].getvalue > records[i].getvalue) {
                    records[key].isYQ = true;
                }
            }

            //拿到自己获得多少钱
            let isMe = FIMUtils.isMe(records[key].uid);
            if (isMe) {
                money = records[key].getvalue;
            }

        }
        console.log(records);


        nickname = StringUtils.decode(nickname)



        if (nickname.length > 13) {
            nickname = nickname.substring(0, 13) + '...'
        }





        let dateTime;
        //拿出第0个的时间
        if (redbagtype == 1) {
            let gettime;

            for (const key in records) {
                gettime = records[key].gettime;
                continue;
            }
            //计算两个时间，用gettime - redbagtime
            let dateNum = gettime - redbagtime

            //计算出相差天数
            var days = Math.floor(dateNum / (24 * 3600));

            //计算出小时数
            var leave1 = dateNum % (24 * 3600); //计算天数后剩余的毫秒数
            var hours = Math.floor(leave1 / 3600);
            //计算相差分钟数
            var leave2 = leave1 % 3600; //计算小时数后剩余的毫秒数
            var minutes = Math.floor(leave2 / 60);

            //计算相差秒数

            var leave3 = leave2 % 60; //计算分钟数后剩余的毫秒数
            var seconds = Math.round(leave3);



            if (days > 0) {
                dateTime = days + '天'
            } else if (hours > 0) {
                if (minutes > 0) {
                    dateTime = hours + '小时' + minutes + '分'
                } else {
                    dateTime = hours + '小时'
                }
            } else if (minutes > 0) {
                dateTime = minutes + '分钟'
            } else if (seconds > 0) {
                dateTime = seconds + '秒'
            }


        }



        this.setState({
            userAvatar: StringUtils.decode(headurl),
            userName: nickname,
            type: redbagtype,
            redBagMoney: money,
            yRedBagLenght: records.length,
            leftnum,
            dateTime,
            list: records
        })


    }

    timestampToTime = (timestamp) => {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes();
        var s = date.getSeconds();
        return M + D + h + m;
    }

    //普通红包
    defaultBox = () => {
        return (
            <div className='defaultBox'>
                <div>
                    <span className='money'>{this.state.redBagMoney}</span>
                    <span className='currency'>积分</span>
                </div>
                <div className='content'>已经存钱包，可用于积分商城兑换商品</div>
            </div>
        )
    }
    //凭手气红包
    redBox = () => {
        return (
            <div className='redBox'>

                <div className='redNumBox'>
                    <span>{this.state.yRedBagLenght}</span>
                    <span>个红包</span>
                    {this.state.leftnum == 0 && <span>,{this.state.dateTime}抢光</span>}
                </div>
                {
                    this.state.list.map((item, index) => {
                        return <div key={index}>
                            <div className='itemUser'>
                                <img src={item.headurl}></img>
                                <div className='user'>
                                    <div>
                                        <div className='userName'>{item.nickname}</div>
                                        <div className='time'>{item.gettime2}</div>
                                    </div>
                                    <div className='right'>
                                        <div className='jf'>{item.getvalue}积分</div>
                                        {
                                            item.isYQ && this.state.leftnum == 0 && <div className='shouqi'>手气最佳</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
        )
    }

    render() {
        const { classes } = this.props;
        return (
            <MBack title='红包' appBarColor='#FC4545' >
                <div className={classes.redbox}></div>
                <img src={BG} className={classes.bgImg}></img>

                <div className='user' style={{ marginTop: 50 }}>
                    <div className='top'>
                        {
                            this.state.userAvatar && <img className='avatar' src={this.state.userAvatar} />
                        }
                        <span>{this.state.userName}发出的红包</span>
                    </div>
                    <div className='textmsg'>{this.state.redbagText}</div>

                </div>



                {this.defaultBox()}
                {this.state.type == 1 && this.redBox()}

            </MBack >
        )
    }
}

export default withRouter(withStyles((theme) => ({
    redbox: {
        backgroundColor: '#FC4545',
        height: 16
    },
    bgImg: {
        width: '100%',
    }

}))(RedBag));